/**
 * The one back affordance in `apps/app`. See the "Back affordance" section of
 * `.agents/docs/conventions/ui-patterns.md` for which screens carry one and why.
 */
import { FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

export const BACK_LINK_CLASS = `inline-flex min-h-touch-target items-center text-body-strong text-primary no-underline ${FOCUS_RING}`;

export const BackButton = ({
  label,
  onBack,
}: {
  label: string;
  onBack: () => void;
}): ReactNode => (
  <button type="button" className={BACK_LINK_CLASS} onClick={onBack}>
    {label}
  </button>
);
